import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {Context} from 'src/common/types'
import {CardsVariation} from './CardsVariation'
import {FourGridDefault} from './DefaultVariation'
import {GridVariation} from './GridVariation'
import {ValuesVariation} from './ValuesVariation'

/**
 * Props for `FourGrid`.
 */
export type FourGridProps = SliceComponentProps<Content.FourGridSlice>

/**
 * Component for "FourGrid" Slices.
 */
const FourGrid = ({slice, index: componentIndex, context}: FourGridProps & {context: Context}): JSX.Element => {
  switch (slice.variation) {
    case 'cards':
      return <CardsVariation slice={slice} componentIndex={componentIndex} pageUid={context.pageUid} />
    case 'grid':
      return <GridVariation slice={slice} />
    case 'default':
      return <FourGridDefault slice={slice} componentIndex={componentIndex} pageUid={context.pageUid} />
    case 'values':
      return <ValuesVariation slice={slice} />
    default:
      return <></>
  }
}

export default FourGrid
